

























































import mixin from './mixin'
import { Tag } from '@/types/tag'

export default mixin.extend({
  data() {
    return {
      tagUid: '',
      options: {},

      infoWindow: {
        show: false,
        title: '',
        subTitle: '',
        value: 0,
        tag: '',
        min: 0,
        max: 0,
        content: {},
        position: { lat: 0, lng: 0 },
        options: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
      },
    }
  },
  methods: {
    // eslint-disable-next-line
    toggleInfoWindow: function(marker: any) {
      this.infoWindow.title = marker.title
      this.infoWindow.tag = marker.tag
      this.infoWindow.subTitle = marker.subTitle
      this.infoWindow.position = { lat: marker.lat, lng: marker.lng }
      this.infoWindow.content = marker
      this.infoWindow.show = true
    },
  },

  computed: {
    tags(): Tag[] {
      return this.$store.state.tag.items as Tag[]
    },
    currentValue(): number | string {
      const tag = this.tags[this.infoWindow.tag]
      if (tag) {
        return this.tags[this.infoWindow.tag].value.toFixed(4)
      }
      return '####'
    },
  },
})
